import { useNfcCardExchangeQuery } from "Api/Queries/useNfcCardExchangeQuery";
import { NfcLayout } from "Components/Layout/NfcLayout";
import { IdleNfcInfo } from "Components/Nfc/IdleNfcInfo";
import { NfcRedirect } from "Components/Nfc/NfcRedirect";
import { NFCCardType } from "Infrastructure/Api/Api";
import { Navigate } from "Navigation/Navigate";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";
import { useParams } from "react-router";

const RESOURCES = Resources.Nfc;

const NfcExchangePage = () => {
  const { t } = useResource();
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, isError } = useNfcCardExchangeQuery(id);

  if (isLoading) {
    return null;
  }

  if (isError || !id || !data) {
    return (
      <NfcLayout title={t(RESOURCES.NfcCard)}>
        <IdleNfcInfo nfcCardNo={id} />
      </NfcLayout>
    );
  }

  const { type, publicID, redirectUrl } = data;

  if (type === NFCCardType.RedirectPayPoint) {
    return (
      <NfcLayout title={t(RESOURCES.NfcCard)}>
        <NfcRedirect redirectUrl={redirectUrl} />
      </NfcLayout>
    );
  }

  if (type === NFCCardType.StandardPayPoint) {
    return (
      <Navigate to={`${appUrl("latest-pay-point-transaction")}/${publicID}`} />
    );
  }

  if (type === NFCCardType.FixedCollectorPayPoint) {
    return (
      <Navigate to={`${appUrl("fixed-collector-paypoint")}/${publicID}`} />
    );
  }

  if (type === NFCCardType.VariableCollectorPayPoint) {
    return (
      <Navigate to={`${appUrl("variable-collector-paypoint")}/${publicID}`} />
    );
  }

  return null;
};

export default NfcExchangePage;
